import { Seo } from '../components/Seo';
import { Reveal } from '../components/Reveal';
import { ArrowIcon } from '../components/ArrowIcon';
import { BRAND } from '../lib/brand';
import { NAVER_MAP_TAROMANCE_URL } from '../lib/externalLinks';

const CHECKLIST = [
  { title: '인원', description: '바 8석과 4인 테이블 하나의 공간입니다. 5인 이상은 미리 문의해 주세요.' },
  { title: '방문 목적', description: '타로 상담이 목적인지, 칵테일과 대화가 목적인지 알려주시면 자리를 맞춰 준비합니다.' },
  { title: '희망 시간', description: '20시–22시는 가장 붐비는 시간대입니다. 여유 있는 상담을 원하시면 이른 저녁을 추천합니다.' }
];

export function ReservePage() {
  return (
    <div className="tm-page">
      <Seo
        title="예약 안내 | 타로맨스"
        description="타로맨스 예약 안내. 네이버 예약 또는 전화로 자리를 준비해 드립니다."
      />

      <section className="tm-page-hero">
        <div className="tm-container">
          <Reveal>
            <p className="tm-eyebrow">Reservation</p>
            <h1 className="tm-display">
              당신의 자리를
              <br />
              <em>미리 준비해 두겠습니다</em>
            </h1>
            <p className="tm-lede">
              아늑한 공간인 만큼 예약 방문을 권장합니다. 네이버 예약이 가장 빠르고, 전화 문의도 환영합니다.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="tm-section">
        <div className="tm-container">
          <div className="tm-split">
            <Reveal>
              <p className="tm-eyebrow">How to Reserve</p>
              <h2 className="tm-h2">예약 방법</h2>
              <div className="tm-contact-grid" style={{ gridTemplateColumns: '1fr', marginTop: 36 }}>
                <a className="tm-contact-item" href={NAVER_MAP_TAROMANCE_URL} target="_blank" rel="noreferrer">
                  <h3>Naver</h3>
                  <strong>네이버에서 예약하기</strong>
                  <span>네이버 지도에서 타로맨스를 검색해 바로 예약할 수 있습니다 →</span>
                </a>
                <a className="tm-contact-item" href={BRAND.phoneLink}>
                  <h3>Phone</h3>
                  <strong>{BRAND.phoneDisplay}</strong>
                  <span>영업시간({BRAND.hours.label} {BRAND.hours.time}) 중 전화 주시면 안내드립니다</span>
                </a>
              </div>
            </Reveal>
            <Reveal delay={100}>
              <p className="tm-eyebrow">Before Booking</p>
              <h2 className="tm-h2">예약 전 확인해 주세요</h2>
              <ol className="tm-steps" style={{ marginTop: 20 }}>
                {CHECKLIST.map((item, index) => (
                  <li className="tm-step" key={item.title}>
                    <span className="tm-step-no">{String(index + 1).padStart(2, '0')}</span>
                    <div>
                      <h3 className="tm-h3">{item.title}</h3>
                      <p className="tm-body-text">{item.description}</p>
                    </div>
                  </li>
                ))}
              </ol>
              <ul className="tm-note-list" style={{ marginTop: 28 }}>
                <li>예약 변경·취소는 방문 전날까지 전화 또는 네이버 예약에서 가능합니다.</li>
                <li>노쇼가 이어질 경우 이후 예약이 제한될 수 있습니다.</li>
                <li>기타 문의는 <a href={`mailto:${BRAND.email}`} style={{ textDecoration: 'underline', textUnderlineOffset: 3 }}>{BRAND.email}</a>로 보내주세요.</li>
              </ul>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="tm-cta-band tm-section">
        <div className="tm-container">
          <Reveal>
            <h2 className="tm-h2">지금 바로 자리를 잡아두세요.</h2>
            <div className="tm-hero-actions">
              <a className="tm-btn tm-btn--solid" href={NAVER_MAP_TAROMANCE_URL} target="_blank" rel="noreferrer">
                네이버에서 예약하기
              </a>
              <a className="tm-btn tm-btn--ghost" href={BRAND.phoneLink}>전화 문의</a>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
